/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Oto_B1_TitleInputs */

const en_simple_oto_b1_title = /** @type {(inputs: Simple_Oto_B1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Describe it`)
};

const id_simple_oto_b1_title = /** @type {(inputs: Simple_Oto_B1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Ceritakan`)
};

/**
* | output |
* | --- |
* | "1. Describe it" |
*
* @param {Simple_Oto_B1_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_oto_b1_title = /** @type {((inputs?: Simple_Oto_B1_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Oto_B1_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_oto_b1_title(inputs)
	return en_simple_oto_b1_title(inputs)
});